import { Actions, createEffect, ofType } from "@ngrx/effects";
import { InstructionActions } from "../actions";
import { catchError, map, mergeMap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { InstructionService } from "src/app/services/instruction.service";
import { merge, of } from "rxjs";

@Injectable()
export class InstructionEffects {
  loadInstructions$ = createEffect(() =>
    this.actions.pipe(
      ofType(InstructionActions.loadInstructions),
      mergeMap((action) =>
        this.instructionService
          .loadInstructions(action.instructionType)
          .pipe(
            map((result) =>
              InstructionActions.loadedInstructions({ ...result }),
            ),
          ),
      ),
    ),
  );

  constructor(
    private readonly actions: Actions,
    private readonly instructionService: InstructionService,
  ) {}
}
